// @ts-nocheck
import { fork } from 'redux-saga/effects';

import account from './account/account.sagas';
import app from './app/app.sagas';
import client from './client/client.sagas';
import creditNote from './creditNote/creditnote.sagas';
import invoice from './invoice/invoice.sagas';
import onBoarding from './onBoarding/onBoarding.sagas';
import settings from './settings/settings.sagas';
import transaction from './transaction/transaction.sagas';

export function* rootSagas() {
  yield fork(app);
  yield fork(account);
  yield fork(client);
  yield fork(creditNote);
  yield fork(invoice);
  yield fork(settings);
  yield fork(transaction);
  yield fork(onBoarding);
}
